/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_SKIN',
  PUT: 'UPDATE_SKIN',
  DELETE: 'DELETE_SKIN',
};

export const appearanceSkinReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        action.payload,
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.index ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.findIndex((x) => x.id == action.index);
      newValues.splice(index, 1);
      return newValues;
    default:
      return state;
  }
};
